import { baseCMSApi } from '@/shared/api/base-cms-api';
import { CMS_ENDPOINTS } from '@/shared/api/endpoints';
import type { FormSubmission } from '@/shared/cms/shared';

// Define the input type for form submission
export interface FormSubmissionInput {
    form: string;
    submissionData: Array<{
        field: string;
        value: string;
    }>;
    recaptchaToken?: string;
}

const formApi = baseCMSApi
    .enhanceEndpoints({
        addTagTypes: ['FormSubmission'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            postForm: build.mutation<FormSubmission, FormSubmissionInput>({
                query: ({ form, submissionData, recaptchaToken }) => ({
                    url: CMS_ENDPOINTS.postForm(),
                    method: 'POST',
                    body: { form, submissionData, recaptchaToken },
                }),
                invalidatesTags: ['FormSubmission'],
            }),
        }),
    });

export const { usePostFormMutation } = formApi;
